@switch (columnName) {
  @case ('name') {
    {{ element.user?.name }}{{ element.name }}
  }
  @case ('date') {
    {{ element.date | date }}
  }
  @case ('from') {
    {{ element.from | date }}
  }
  @case ('templateName') {
    {{ element.templateCode }} {{ element.templateName }}
  }
  @case ('scheduleTemplate') {
    {{ element.scheduleTemplate?.name }}
  }
  @case ('department') {
    {{ element.department?.name }}
  }
  @case ('planValidity') {
    <app-ui-pill [name]="element[columnName]"></app-ui-pill>
  }
  @case ('departments') {
    @for (department of element.departments; track $index) {
      <div>
        {{ department?.name }}
      </div>
    }
    @for (departmentGroup of element.departmentGroups; track $index) {
      <div>
        {{ departmentGroup?.name }}
      </div>
    }
  }
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      [ariaLabel]="'edit' | translate"
      (click)="buttonFunctions.edit()"
    ></app-ui-button>
  }
  @case ('delete') {
    <app-ui-button
      buttonType="icon-button"
      icon="delete"
      [ariaLabel]="'delete' | translate"
      appConfirmDialog
      [confirmEntityName]="element?.name || element?.templateName"
      (confirmed)="buttonFunctions.delete()"
    ></app-ui-button>
  }
  @case ('scheduleStartTime') {
    {{ element.scheduleStartTime | timeDisplay }}
  }
  @case ('watch1') {
    {{ element.watch1 | timeDisplay }}
  }
  @case ('watch2') {
    {{ element.watch2 | timeDisplay }}
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
